<template>
  <div
    class="home"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
      <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left eng_left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                Home
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                Regong Works Exhibition
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                Regong Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                Cultural and Creative Design Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                Inheritor
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                Database
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                News Updates
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                About Us
              </div>
            </router-link>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <div @click="goBack">
          <img
            class="backImg"
            src="../../assets/mobile/back.png"
            alt=""
          />
        </div>
        <el-input
          class="searchMobileInput"
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="Info.name"
        >
        </el-input>
        <div class="searchButton eng_searchButton" @click="mobileHandleSearch">
          Search
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">Home</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">Regong Works Exhibition</router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale"
                >Regong Exhibition and Sales</router-link
              >
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture"
                >Cultural and Creative Design Exhibition and Sales</router-link
              >
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">Database</router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">News Updates</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">About Us</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <Pic-top></Pic-top>
      <!-- <div class="image">
        <div class="text">AI assisted cultural and creative customization</div>
      </div> -->
    </div>
    <div class="dataBaseSearchTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade"
            >AI assisted cultural and creative customization</span
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color" v-if="id==1">Retrieval</span>
          <span class="color" v-if="id==2">Generate</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetailContent">
      <div class="section">
        <div class="one">
          <div
            class="content_top eng_content_top wow animate__fadeInDown animate__animated"
          >
            <div v-if="id == 1">
              <p>
                Instructions: Enter the specific category you want to retrieve,
                and click the search button to retrieve the corresponding Regon
                Thangka element. At present, the search categories supported
                include: flowers, grass, auspicious clouds, mountains, water
                patterns, fire, magic weapons, auspicious beasts, guardian
                diamond and architecture.
              </p>
              <p>
                Note that the retrieved elements come from the works of Thangka
                in the Regon area. The copyright belongs to the original author.
                Please do not use them for commercial purposes. For commercial
                design, please log in to the database to apply for authorization
                or use AI generation elements.
              </p>
            </div>
            <div v-if="id == 2">
              Instructions: Enter the specific category you want to retrieve,
              and click the generate button to generate hot Gong Thangka
              elements. At present, the generation categories supported by the
              beta version include four types of non-Buddhist pattern elements:
              flower, fire, cloud and water.
            </div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 1">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button eng_button" @click="handleSearch">Retrieve</div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 2">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button eng_button" @click="beingSearch">generate</div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in mobileList" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="loading"
            element-loading-spinner="el-icon-loading"
          ></div>
          <div class="algorithm" v-if="id == 1">
            <div class="content">
              <h1>Introduction to Retrieval Algorithms</h1>
              <div class="photo">
                <img src="../../assets/cultural/1-3.png" alt="" />
                <div>
                  Figure Using this algorithm to detect Thangka elements can
                  effectively reduce missed and false detections.
                </div>
              </div>
              <div class="introduce eng_introduce">
                <p>
                  Search algorithm support: Zhang Xiaojuan, Zhao Yuanhao, Zhao
                  Yang, Thangka element automatic detection algorithm based on
                  circular smoothing YOLOv5 Ghost
                </p>
                <p>
                  As the main form of expression of Regong art and the artistic
                  carrier of Tibetan Buddhism, Thangka is rich in content,
                  complex in structure, and rich in Buddhist elements. To
                  understand and appreciate it, you need to reserve a lot of
                  professional knowledge of Thangka, and it is a time-consuming
                  and laborious process to manually annotate and explain various
                  elements of each Thangka. In addition, designers need to
                  manually collect specific categories of materials when using
                  them, which is a cumbersome process. Therefore, in order to
                  popularize, promote, and utilize the design elements in
                  Thangka, a Thangka element automatic detection algorithm is
                  proposed, which accurately detects Thangka elements based on
                  neural networks and rotation detection boxes.
                </p>
              </div>
            </div>
          </div>
          <div class="algorithm" v-if="id == 2">
            <div class="content">
              <h1>Introduction to Generation Algorithm</h1>
              <div class="photo">
                <img src="../../assets/cultural/2-3.jpg" alt="" />
                <div>
                  Figure By using this method, the model can smoothly and
                  controllably generate different content and styles of Regong
                  elements.
                </div>
              </div>
              <div class="introduce eng_introduce">
                <p>
                  Generation algorithm support:Y. Zhao, H. Li, Z. Zhang, Y. Chen, Q. Liu, X. Zhang, Regional Traditional Painting Generation Based on Hierarchical and Controllable Disentanglement Model, IEEE Transactions on Circuits and Systems for Video Technology (TCSVT), 2023.
                </p>
                <p>
                  By designing a controllable style content deconstruction
                  Generative model, this method decouples the generation of
                  style and content, the generation of overall layout and local
                  details, and can learn the generation of Regong Elements of
                  art 'style through limited samples. In order to respect
                  religious customs, this algorithm beta only provides AI
                  generation for specific categories of non Buddhist elements.
                  The generated results have a certain degree of randomness, do
                  not represent the level of Regong's artistic works, do not
                  contain any religious views, and are only used to assist in
                  related designs. For more generated results and algorithm
                  details, please refer to relevant academic papers for academic
                  exchange only.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">Manual customization services</div>
          <div class="hidden-sm-and-up">Customized services</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="home" v-else-if="this.language == 'en'">
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
      <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left za_left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                ངོ་བྱང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                རྒྱུན་འཛིན་པ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                གྲངས་མཛོད།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                གསར་འགྱུར་གྱི་གནས་ཚུལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                ང་ཚོའི་སྐོར།
              </div>
            </router-link>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <div @click="goBack">
          <img
            class="backImg"
            src="../../assets/mobile/back.png"
            alt=""
          />
        </div>
        <el-input
          class="searchMobileInput"
          placeholder="ནང་དོན་རོགས་།"
          prefix-icon="el-icon-search"
          v-model="Info.name"
        >
        </el-input>
        <div class="searchButton" @click="mobileHandleSearch">འཚོལ་བཤེར།</div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index"> ངོ་བྱང་།</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
              </router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།
              </router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture"
                >རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།</router-link
              >
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">གྲངས་མཛོད། </router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">གསར་འགྱུར་གྱི་གནས་ཚུལ།</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about"> ང་ཚོའི་སྐོར།</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <Pic-top></Pic-top>
      <!-- <div class="image">
        <div class="text">AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།</div>
      </div> -->
    </div>
    <div class="dataBaseSearchTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade"
            >AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།
          </span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color" v-if="id==1"> བཤེར་འཚོལ། </span>
          <span class="color" v-if="id==2"> གྲུབ་པ་ </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetailContent">
      <div class="section">
        <div class="one">
          <div
            class="content_top za_content_top wow animate__fadeInDown animate__animated"
          >
            <div v-if="id == 1">
              <p>
                བེད་སྤྱོད་གསལ་བཤད།ནང་འདྲེན་བྱེད་པར་མཁོ་བའི་དམིགས་བསལ་རིགས།དཔྱད་འཚོལ་གཅུས་སྒོ་མནན་ནས་རེབ་གོང་ཐང་གའི་གཞི་རྒྱུར་དཔྱད་འཚོལ་དང་བཙལ་འཚོལ་བྱེད་པ་དང་།མིག་སྔར་རྒྱབ་སྐྱོར་བྱེད་པའི་དཔྱད་འཚོལ་རིགས་སུ་མེ་ཏོག་དང་།རྩྭ།ཞང་ཡུན།རི།ཆུ་རིས།མེ།ཆོས་ཆས་ནོར་བུ།རུའེ་རི་དྭགས།སྲུང་སྐྱོབ་རྡོ་རྗེ་དང་ཨར་ལས་བཅས་ཚུད་ཡོད།
                ངས་བལྟས་ན།
              </p>
              <p>
                གཉིས།
                འཚོལ་ཞིབ་བྱེད་པའི་གཞི་རྒྱུ་ནི་རེབ་གོང་ས་ཁུལ་གྱི་ཐང་གའི་བརྩམས་ཆོས་ལས་བྱུང་བ་དང་།
                པར་དབང་ནི་གསར་གཏོད་རྩོམ་པ་པོར་དབང་བས་ཚོང་ལས་ཐད་སྤྱོད་མི་རུང་།
                གལ་ཏེ་ཚོང་ལས་ཇུས་འགོད་ཐད་སྤྱོད་དགོས་ན།
                གཞི་གྲངས་མཛོད་ནས་རེ་ཞུ་བྱས་ཏེAIགྲུབ་པའི་གཞི་རྒྱུ་བཀོལ་དགོས།
              </p>
            </div>
            <div v-if="id == 2">
              བཅུ་གསུམ། བེད་སྤྱོད་གསལ་བཤད།
              འཚོལ་ཞིབ་བྱ་དགོས་པའི་དམིགས་བསལ་གྱི་རིགས་དབྱེ་ནང་འཇུག་བྱས་ཏེ།
              འདྲེས་གྲུབ་མཐེབ་གནོན་མནན་ནས་རེབ་གོང་ཐང་གའི་གཞི་རྒྱུ་གྲུབ་པ་བྱ་དགོས།
              མིག་སྔར་ཚོད་ལྟའི་པར་གཞི་དེའི་རྒྱབ་སྐྱོར་ཐོབ་པའི་ཁོངས་གཏོགས་སུ་མེ་ཏོག་དང་།
              མེ། སྤྲིན། ཆུ་བཅས་ནང་བསྟན་མིན་པའི་གཞི་རྒྱུ་རིགས་བཞི་ཚུད་ཡོད།
            </div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 1">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button" @click="handleSearch">检索</div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 2">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button" @click="beingSearch">生成</div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in mobileList" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
            element-loading-spinner="el-icon-loading"
          ></div>
          <div class="algorithm" v-if="id == 1">
            <div class="content">
              <h1>གསུམ། དཔྱད་འཚོལ་རྩི་ཐབས་ངོ་སྤྲོད།</h1>
              <div class="photo">
                <img src="../../assets/cultural/1-3.png" alt="" />
                <div>
                  བཞི། རི་མོ་དང་པོ།
                  རྩི་ཐབས་འདི་སྤྱད་ནས་ཐང་གའི་གཞི་རྒྱུ་ལ་ཞིབ་བཤེར་ཚད་ལེན་བྱས་ན་བཤེར་ལུས་ཐེབས་པ་དང་ཞིབ་བཤེར་མ་ཐུབ་པའི་གནས་ཚུལ་ཉུང་དུ་གཏོང་ཐུབ།
                </div>
              </div>
              <div class="introduce">
                <p>
                  ལྔ། འཚོལ་ཞིབ་རྩིས་ཐབས་ལ་རྒྱབ་སྐྱོར་བྱེད་པ། ཀྲང་ཞའོ་ཅོན།
                  ཀྲའོ་ཡོན་ཧའོ།
                  ཀྲའོ་དབྱང་བཅས་ཀྱི་གདུབ་དབྱིབས་འཇམ་འདྲེདYOLOv5-Ghostཡི་ཐང་གའི་གཞི་རྒྱུ་རང་འགུལ་ཞིབ་བཤེར་རྩིས་ཐབས་ལ་བརྟེན་ནས་ལག་བསྟར་བྱེད།
                </p>
                <p>
                  དྲུག
                  ཐང་ག་ནི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་མཚོན་ཚུལ་གཙོ་བོ་ཞིག་དང་བོད་བརྒྱུད་ནང་བསྟན་གྱི་སྒྱུ་རྩལ་གཞི་རྟེན་ཞིག་ཡིན་པའི་ངོས་ནས།
                  དེའི་ནང་དོན་ཕུན་སུམ་ཚོགས་ཤིང་གྲུབ་ཆ་རྙོག་འཛིང་ཆེ་བ།
                  ཆོས་ལུགས་ཀྱི་གྲུབ་ཆ་ཅུང་མང་བ་བཅས་ཡོད་པས།
                  ཐང་ག་ཤེས་རྟོགས་དང་མྱོང་རོལ་བྱེད་པར་ཐང་གའི་ཆེད་ལས་ཤེས་བྱ་འབོར་ཆེན་གསོག་འཇོག་བྱེད་དགོས།
                  མིས་ཐབས་ལ་བརྟེན་ནས་ཐང་ག་རེའི་གཞི་རྒྱུ་སྣ་ཚོགས་ལ་གསལ་བཤད་དང་འགྲེལ་བཤད་རྒྱག་པ་ནི་དུས་ཚོད་དང་ནུས་ཤུགས་ཟད་གྲོན་ཆེ་བའི་བརྒྱུད་རིམ་ཞིག་ཡིན།
                  གཞན་ཇུས་འགོད་པས་བེད་སྤྱོད་གཏོང་སྐབས་དམིགས་བཀར་རིགས་ཀྱི་རྒྱུ་ཆ་མི་ཐབས་ལ་བརྟེན་ནས་བསྡུ་རུབ་བྱེད་དགོས་པ་དང་བརྒྱུད་རིམ་རྙོག་འཛིང་ཆེ་ཙམ་ཡོད།
                  དེར་བརྟེན།
                  ཐང་གའི་ཁྲོད་ཀྱི་ཇུས་འགོད་གཞི་རྒྱུ་ཁྱབ་གདལ་དང་དར་སྤེལ།
                  བེད་སྤྱོད་བཅས་བྱ་ཆེད།
                  ཐང་གའི་གཞི་རྒྱུ་རང་འགུལ་ཞིབ་དཔྱད་ཚད་ལེན་རྩི་ཐབས་བཏོན་པ་དང་།
                  དབང་རྩའི་དྲ་རྒྱ་དང་འཁོར་སྐྱོད་ཞིབ་དཔྱད་ཚད་ལེན་སྒྲོམ་གཞིས་ཐང་གའི་གཞི་རྒྱུ་ལ་ཞིབ་དཔྱད་ཚད་ལེན་ཡང་དག་པ་བྱས་པ་རེད།
                </p>
              </div>
            </div>
          </div>
          <div class="algorithm" v-if="id == 2">
            <div class="content">
              <h1>རྩི་ཐབས་ངོ་སྤྲོད་བྱེད་པ།</h1>
              <div class="photo">
                <img src="../../assets/cultural/2-3.jpg" alt="" />
                <div>
                  བཅུ་བཞི། རི་མོ་དང་པོ།
                  བྱ་ཐབས་འདིའི་དཔེ་དབྱིབས་བེད་སྤྱད་ན་སྟབས་བདེའི་ངང་ཚོད་འཛིན་བྱེད་ཐུབ་པའི་རེབ་གོང་གི་གཞི་རྒྱུ་མི་འདྲ་བའི་ནང་དོན་དང་ཁྱད་ཆོས་ཆགས་ཐུབ།
                </div>
              </div>
              <div class="introduce">
                <p>
                  འགྲུབ་པའི་རྩི་ཐབས་རྒྱབ་སྐྱོར།：Y. Zhao, H. Li, Z. Zhang, Y. Chen, Q. Liu, X. Zhang, Regional Traditional Painting Generation Based on Hierarchical and Controllable Disentanglement Model, IEEE Transactions on Circuits and Systems for Video Technology (TCSVT), 2023.
                </p>
                <p>
                  བཅུ་དྲུགབྱ་ཐབས་འདིས་ཚོད་འཛིན་ཐུབ་པའི་རྣམ་པ་དང་ནང་དོན་གྱི་ཆགས་གཞི་དེ་དཔེ་དབྱིབས་སུ་གྲུབ་པར་བྱས་ཏེ།
                  རྣམ་པ་དང་ནང་དོན་མཉམ་འདྲེས་ཐུབ་པ་དང་སྤྱི་ཡོངས་ཀྱི་བཀོད་སྒྲིག་དང་ཆ་ཤས་ཀྱི་ཞིབ་ཕྲའི་རྣམ་པ་ཆགས་པ་བྱས་ནས།
                  ཚད་ཡོད་ཀྱི་མ་དཔེའི་སློབ་སྦྱོང་ལ་བརྟེན་ནས་རེབ་གོང་སྒྱུ་རྩལ་གྱི་གཞི་རྒྱུ་ཁྱད་ཆོས་ཆགས་པར་བྱེད་དགོས།
                  ཆོས་ལུགས་ཀྱི་གོམས་སྲོལ་ལ་བརྩི་འཇོག་བྱ་ཆེད།
                  དངོས་ཚན་ཚོད་ལྟའི་པར་གཞི་འདིས་དམིགས་བསལ་གྱི་གཏན་འཁེལ་བྱས་ཡོད་བའི་ནང་བསྟན་གྱི་གཞི་རྒྱུ་མ་ཡིན་པརAIའགྲུབ་འབྲས་བྱེད།
                  འགྲུབ་འབྲས་ལ་སྐབས་བསྟུན་རང་བཞིན་ངེས་ཅན་ལྡན་པས་རེབ་གོང་སྒྱུ་རྩལ་བརྩམས་ཆོས་ཀྱི་ཆུ་ཚད་མཚོན་མི་ཐུབ་པ་དང་ཆོས་ལུགས་ཀྱི་ལྟ་བ་གང་ཡང་ཚུད་མེད་པར།
                  འབྲེལ་ཡོད་ཇུས་འགོད་ལ་རམ་འདེགས་བྱེད་པ་ཁོ་ནར་སྤྱོད་ཀྱིན་ཡོད།
                  དེ་ལས་མང་བའི་གྲུབ་འབྲས་དང་རྩི་ཐབས་ཀྱི་ཞིབ་ཆ་ནི་དེའི་སྐོར་གྱི་རིག་གཞུང་དཔྱད་རྩོམ་ལ་དཔྱད་གཞི་དང་ལྟ་ཀློག་དང་རིག་གཞུང་སྤེལ་རེས་ཁོ་ན་བྱ་ཆོག
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">མིས་བཟོས་ཁྱད་བཟོ་ཞབས་ཞུ།</div>
          <div class="hidden-sm-and-up">ཁྱད་བཟོའི་ཞབས་ཞུ།</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="home" v-else>
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
      <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                首页
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                热贡作品展
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                热贡作品展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                文创设计与展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                传承人
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                数据库
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                新闻动态
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                关于我们
              </div>
            </router-link>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <div @click="goBack">
          <img
            class="backImg"
            src="../../assets/mobile/back.png"
            alt=""
          />
        </div>
        <el-input
          class="searchMobileInput"
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="Info.name"
        >
        </el-input>
        <div class="searchButton" @click="mobileHandleSearch">搜索</div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">首页</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">热贡作品展</router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">热贡作品展销</router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture">文创设计与展销</router-link>
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">数据库</router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">新闻动态</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">关于我们</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <Pic-top></Pic-top>
      <!-- <div class="image">
        <div class="text">AI辅助文创定制</div>
      </div> -->
    </div>
    <div class="dataBaseSearchTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade">AI辅助文创定制</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color" v-if="id==1">检索</span>
          <span class="color" v-if="id==2">生成</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetailContent">
      <div class="section">
        <div class="one">
          <div class="content_top wow animate__fadeInDown animate__animated">
            <div v-if="id == 1">
              <p>
                使用说明：输入所需检索的特定类别，点击检索按钮检索对应热贡唐卡元素。目前支持的检索类别包含：花朵、草、祥云、山、水纹、火、法器宝器、瑞兽、护法金刚和建筑。
              </p>
              <p>
                注意检索的元素来自于热贡地区唐卡作品，版权归原创作者所有，请勿用于商业用途。如需商业设计使用，请登录数据库申请授权或使用AI生成元素。
              </p>
            </div>
            <div v-if="id == 2">
              使用说明：输入所需检索的特定类别，点击生成按钮生成热贡唐卡元素。目前该测试版支持的生成类别包含花、火、云、水四类非佛教纹样元素。
            </div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 1">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button" @click="handleSearch">检索</div>
          </div>
          <div class="search hidden-xs-only" v-if="id == 2">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入内容"
              clearable
            ></el-input>
            <div class="button" @click="beingSearch">生成</div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div class="content_middle">
            <div class="item" v-for="(item, index) in mobileList" :key="index">
              <img :src="URL + item.url" alt="" />
            </div>
          </div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
          ></div>
          <div class="algorithm" v-if="id == 1">
            <div class="content">
              <h1>检索算法介绍</h1>
              <div class="photo">
                <img src="../../assets/cultural/1-3.png" alt="" />
                <div>
                  图. 使用该算法对唐卡元素进行检测可以有效降低漏检、误检。
                </div>
              </div>
              <div class="introduce">
                <p>
                  检索算法支持：张效娟，赵元豪，赵洋，基于环形平滑YOLOv5-Ghost的唐卡元素自动检测算法
                </p>
                <p>
                  唐卡作为热贡艺术的主要表现形式和藏传佛教的艺术载体，其内容丰富、结构复杂、佛元素较多，对其理解与欣赏需要储备大量的唐卡专业知识，而人工对每张唐卡的各种元素进行标注与讲解是一件极为耗时耗力的过程。此外，设计师在使用时要对特定类别的素材进行人工收集，过程较为繁琐。因此，为了普及、推广、利用唐卡中的设计元素，提出了一种唐卡元素自动检测算法，基于神经网络及旋转检测框对唐卡元素进行精确检测。
                </p>
              </div>
            </div>
          </div>
          <div class="algorithm" v-if="id == 2">
            <div class="content">
              <h1>生成算法介绍</h1>
              <div class="photo">
                <img src="../../assets/cultural/2-3.jpg" alt="" />
                <div>
                  图. 使用本方法模型可以顺滑可控的生成不同的热贡元素内容及风格。
                </div>
              </div>
              <div class="introduce">
                <p>
                  生成算法支持：Y. Zhao, H. Li, Z. Zhang, Y. Chen, Q. Liu, X. Zhang, Regional Traditional Painting Generation Based on Hierarchical and Controllable Disentanglement Model, IEEE Transactions on Circuits and Systems for Video Technology (TCSVT), 2023.
                </p>
                <p>
                  本方法通过设计可控风格内容解构生成模型，将风格与内容的生成解耦、将整体布局与局部细节的生成解耦，可以通过有限的样本学习热贡艺术元素风格的生成。为了尊重宗教习俗，本算法测试版仅提供特定类别的非佛教元素进行AI生成。生成结果具有一定随机性，不代表热贡艺术作品水平、不包含任何宗教观点，仅用于辅助相关设计。更多生成结果及算法细节，可以参考该工作相关学术论文，仅供学术交流。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">人工定制服务</div>
          <div class="hidden-sm-and-up">定制服务</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { sourceImgPage } from "../../api/management";
import PicTop from "../../components/picsTop.vue";
import CommonBottom from "../../components/commonbottom";
import "swiper/dist/css/swiper.min.css";
import { throttle } from 'lodash'
export default {
  components: {
    PicTop,
    CommonBottom,
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
    "$route.path": {
      handler(toPath, fromPath) {
        if (toPath == "/index") {
          this.active = 1;
        } else if (
          toPath == "/exhibition" ||
          toPath == "/exhibitionDetail" ||
          toPath == "/exhibitionWorkDetail" ||
          toPath == "/paintingExhibition" ||
          toPath == "/exhibitionWork" ||
          toPath == "/exhibitionBaseDetail"
        ) {
          this.active = 2;
        } else if (
          toPath == "/exhibitionSale" ||
          toPath == "/exhibitionSearchDetail" ||
          toPath == "/exhibitionMade" ||
          toPath == "/exhibitionSaleSearch"
        ) {
          this.active = 4;
        } else if (
          toPath == "/culture" ||
          toPath == "/culturalGoodsDetail" ||
          toPath == "/culturalMoreGoods" ||
          toPath == "/culturalCustomMade" ||
          toPath == "/culturalCustomSearchDetail" ||
          toPath == "/culturalCustomDetail"
        ) {
          this.active = 5;
        } else if (
          toPath == "/database" ||
          toPath == "/dataBaseWork" ||
          toPath == "/dataBaseDetail" ||
          toPath == "/dataBaseSearch"
        ) {
          this.active = 3;
        } else if (toPath == "/news" || toPath == "/newsDetail") {
          this.active = 9;
        } else if (toPath == "/about") {
          this.active = 10;
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      value: "",
      URL: process.env.VUE_APP_WEB_URL,
      num: 1,
      active: 5,
      searchContent: "",
      searchName: "",
      list: [],
      listOne: [
        {
          imgSrc: require("../../assets/cultural/jiansuo/76.png"),
          title: "使用用例与介绍",
          introduce:
            "热贡艺术早期作品手法古朴粗放，绘画带有印度、尼泊尔风格，给人以博大之感。至17世纪中叶，艺术日趋精湛，工笔重彩，画风趋向华丽。18世纪的名画师有魏唐华旦、博拉金巴、扎西加，19世纪的名画师有泵香曲热刹、夏吾才让19世纪以来，热贡艺术作品艳丽、细腻，追求装饰趣味，大量用金，使画面更显金碧辉煌。夏吾才让19世纪以来，热贡艺术作品艳丽、细腻，追求装饰趣味，大量用金，使画面更显金碧辉煌。",
        },
      ],
      queryInfo: {
        current: 1,
        pageSize: 12,
        name: "花",
      },
      total: null,
      mobileList: [],
      mobileTotal: null,
      Info: {
        current: 1,
        pageSize: 12,
        name: "花",
      },
      loading: true,
      isLoading:false,
      language: this.$store.state.language,
      languageList:[
        {
          id:1,
          value: 'cn',
          label: '中文'
        },
        {
          id:2,
          value: 'en',
          label: 'བོད་ཡིག །'
        },
        {
          id:3,
          value: 'eng',
          label: 'English'
        }
      ],
      templeContact:'18997193666'
    };
  },
  mounted() {
    this.getPCorMobile();
  },
  methods: {
    handleChange(num) {
      if (num <= 5) {
        this.$store.commit("changeNum", num);
      } else if (num == 9) {
        this.$store.commit("changeNum", num);
      } else if (num == 10) {
        this.$store.commit("changeNum", num);
      }
    },
    goExhibitionSearchDetail(index) {
      this.$router.push({
        path: "/exhibitionSearchDetail",
        query: { type: index },
      });
    },
    goBack() {
      this.$router.push("/culturalCustomMade");
    },
    changeLanguages(num) {
      if (num == 1) {
        this.language = "en";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 2) {
        this.language = "cn";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 3) {
        this.language = "eng";
        this.$store.commit("changeLanguage", this.language);
      }
    },
    async getSourceImgPage() {
      this.loading = true
      const res = await sourceImgPage(this.queryInfo);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.list = this.list.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    // 手机
    async getMobileProductPage() {
      this.loading = true
      const res = await sourceImgPage(this.Info);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.mobileList = this.mobileList.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
    },
    mobileHandleSearch() {
      this.Info.current = 1;
      this.mobileList = [];
      this.mobileTotal = null
      setTimeout(() => {
        this.getMobileProductPage();
      }, 500);
    },
    handleSearch() {
      this.queryInfo.current = 1;
      this.list = [];
      setTimeout(() => {
        this.getSourceImgPage();
      }, 500);
    },
    beingSearch() {
      this.queryInfo.current = 1;
      this.list = [];
      if (
        this.queryInfo.name != "花" &&
        this.queryInfo.name != "火" &&
        this.queryInfo.name != "云" &&
        this.queryInfo.name != "水" &&
        this.queryInfo.name != ""
      ) {
        this.$message("目前该生成模型测试版仅支持花、火、云、水四类");
        this.queryInfo.name = "";
      } else if (this.queryInfo.name == "") {
        this.queryInfo.name = "花";
      } else {
        setTimeout(() => {
          this.getSourceImgPage();
        }, 500);
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileProductPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getSourceImgPage();
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 500 >= scrollHeight) {
        //到底后要去触发的事件
        if(this.isLoading) {
          if(this.list.length - 1 !== this.total) {
            if (this.queryInfo.current * 12 >= this.total) {
              this.isLoading = false
              return this.$message("数据加载完毕");
            }
            this.loading = true;
            this.queryInfo.current++;
            this.getSourceImgPage();
          }
        }
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 600 >= scrollHeight) {
        //到底后要去触发的事件
        if(this.isLoading) {
          if(this.mobileList.length - 1 !== this.mobileTotal) {
            if (this.Info.current * 12 >= this.mobileTotal) {
              this.isLoading = false
              return this.$message("数据加载完毕");
            }
            this.loading = true;
            this.Info.current++;
            this.getMobileProductPage();
          }
        }
      } else {
        this.isLoading = true
      }
    },2000),
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    goCulturalCustomMade() {
      this.$router.push("/culturalCustomMade");
    },
    changePCLanguages() {
      let language = this.language
      this.$store.commit("changeLanguage", language);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss" scoped>
.home {
  position: relative;
  .searchInput {
    z-index: 999;
    position: fixed;
    top: 60px;
    right: 20%;
    .el-input__inner {
      color: #99131a;
    }
    .el-input__icon {
      height: 100%;
      width: 25px;
      text-align: center;
      transition: all 0.3s;
      line-height: 40px;
      position: absolute;
      left: 172px;
      top: 0;
      color: #99131a;
    }
  }
  .homeTop {
    position: relative;
    font-family: "fangzang";
    .homeTopList {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      text-align: center;
      display: flex;
      width: 100%;
      height: 50px;
      background-color: #10161e;
      opacity: 0.9;
      .left {
        font-family: "fangzang";
        width: 100%;
        height: 50px;
        display: flex;
        white-space: nowrap;
        justify-content: center;
        .navbar_dropdown_group {
          margin-left: 0.4rem;
          a {
            display: inline-block;
            text-align: center;
            font-size: 16px;
            color: #fff;
            transition: all 0.3s ease;
            &:hover {
              color: #feae03;
            }
            .tarbar_title {
              height: 50px;
              line-height: 50px;
            }
          }
          .tar {
            .tarbar_title {
              border-bottom: 0;
            }
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
          //记住切不可将router-link-exact-active与tar调换位置
          .router-link-exact-active {
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
        }
        .navbar_dropdown_group:first-child {
          margin-left: 0;
        }
        .change {
          margin-left: 0.1rem;
          display: flex;
          align-items: center;
          width: 100px;
          /deep/.el-select {
            width: 90px;
            height: 30px;
            .el-input {
              .el-input__inner{
                height: 30px;
                text-align: center;
                background-color: #550a0d;
                border: none;
                color: #fff;
              }
              .el-input__suffix{
                .el-input__suffix-inner{
                  .el-select__caret{
                    color: #fff;
                  }
                  .el-input__icon {
                    height: 30px;
                    line-height: 30px;
                  }
                }
              }
            }
            .select-popper {
              .el-scrollbar {
                .el-select-dropdown__wrap{
                  .el-scrollbar__view {
                    .selected{
                      color: #550a0d;
                    }
                  }
                }

              }
            }
          }
        }
      }
      .za_left {
        // left: 8%;
        .navbar_dropdown_group {
          margin-left: 0.1rem;
          a {
            font-size: 18px;
          }
        }
      }
      .eng_left {
        font-family: "Times New Roman", Times, serif;
        // left: 9%;
        .navbar_dropdown_group {
          margin-left: 0.1rem;
          a {
            font-size: 13px;
          }
        }
        .changeBox {
          font-family: "fangzang";
        }
      }
    }
    .sections {
      display: flex;
      margin: 0 auto;
      justify-content: center;
      .indexTopRight {
        background: url("../../assets/indexImage/indexTopRightRed.png")
          no-repeat center;
        background-size: cover;
        height: 680px;
        width: 488px;
        font-family: "fangzang";
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: tb-rl;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column-reverse;
          color: #fff;
          .hot_art {
            font-size: 70px;
          }
          .dream {
            font-size: 50px;
          }
        }
      }
    }
  }
  .dataBaseSearchTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  // 手机
  .menu_mobile {
    .header_mobile_title {
      height: 1.1rem;
      box-shadow: 0 2px 2px #d8d9da;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding: 0 0.1rem;
      img {
        width: 0.5rem;
        height: 0.5rem;
      }
      h2 {
        text-align: center;
        font-weight: 400;
        font-size: 0.345rem;
      }
      span {
        width: 0.5rem;
        height: 0.5rem;
      }
      .backImg {
        width: 0.4rem;
        height: 0.4rem;
        z-index: 999;
      }
      /deep/.searchMobileInput {
        position: relative;
        height: 0.6rem;
        width: 5rem;
        border: none;
        .el-input__inner {
          height: 0.6rem;
          width: 5rem;
          color: #99131a;
          border-radius: 1rem;
          text-align: center;
          background-color: #f5f5f5;
        }
        .el-input__icon {
          text-align: center;
          line-height: 0.6rem;
          position: absolute;
          left: 1.3rem;
        }
      }
      .searchButton {
        height: 0.6rem;
        line-height: 0.6rem;
        width: 1rem;
        background-color: #971118;
        color: #fff;
        text-align: center;
        border-radius: 0.3rem;
        font-size: .32rem;
      }
      .titleRight {
        .userSearch {
          display: flex;
          .userSearch_Photo,
          .userSearch_Search {
            width: 0.5rem;
            height: 0.5rem;
            background-color: #971118;
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 0.25rem;
              height: 0.3rem;
            }
          }
          .userSearch_Search {
            margin-left: 0.2rem;
            img {
              width: 0.3rem;
              height: 0.3rem;
            }
          }
        }
      }
    }
    .header_mobile_content {
      position: fixed;
      top: 0;
      background: rgba(65, 120, 190, 0.8);
      width: 100vw;
      height: 100vh;
      z-index: 999;
      .mobile_content_top {
        height: 1.2rem;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        width: 100%;
        span {
          padding-right: 1rem;
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          background: url("../../assets/mobile/cancle.png") center center
            no-repeat;
          transform: rotate(180deg);
        }
      }
      .mobile_content_middle {
        display: flex;
        justify-content: center;
        flex-direction: column;
        a {
          display: block;
          padding: 0 0.25rem;
          line-height: 0.9rem;
          font-size: 0.31rem;
          color: #fff;
          text-align: center;
        }
      }
    }
    .image {
      position: relative;
      background: url("../../assets/newImageBgc/mobile_newImage_1.jpg")
        no-repeat center center;
      background-size: cover;
      height: 3rem;
      .text {
        font-size: 0.5rem !important;
        text-align: center;
        width: 2.5rem;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        color: #fff;
        font-family: "fangzang";
      }
      .eng_text {
        font-family: "Times New Roman", Times, serif;
      }
    }
  }
  .culturalCustomDetailContent {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-position: 100% 100%;
    position: relative;
    background-size: 7%;
    .section {
      .one {
        .content_top {
          text-align: justify;
          margin: 50px 0;
          div {
            text-indent: 2em;
            background-color: #f5f5f5;
            line-height: 1.5;
            padding: 20px 30px;
          }
        }
        .eng_content_top {
          div {
            text-indent: 0;
          }
        }
        .za_content_top {
          div {
            font-size: 18px;
          }
        }
        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 50px;
          .el-input {
            width: 300px;
          }
          .button {
            cursor: pointer;
            margin-left: -4px;
            text-align: center;
            color: #fff;
            font-family: "fangzang";
            font-size: 16px;
            height: 40px;
            line-height: 40px;
            width: 80px;
            background-color: #304363;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
          .eng_button {
            font-family: "Times New Roman", Times, serif;
          }
        }
        .content_middle {
          display: flex;
          flex-wrap: wrap;
          .item {
            width: 160px;
            margin-right: 48px;
            margin-bottom: 48px;
            img {
              width: 160px;
              height: 160px;
            }
          }
          .item:nth-child(6n) {
            margin-right: 0;
          }
        }
        /deep/.loading {
          margin-bottom: 20px;
          .el-loading-mask {
            .el-loading-spinner {
              .el-icon-loading {
                color: #ef3731;
              }
              .el-loading-text {
                color: #ef3731;
              }
            }
          }
        }
        .algorithm {
          .content {
            padding: 20px 30px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            .introduce {
              margin-top: 20px;
              line-height: 24px;
              text-align: justify;
              p {
                text-indent: 2em;
              }
            }
            .eng_introduce {
              p {
                text-indent: 0;
              }
            }
            .photo {
              text-align: center;
              margin-top: 20px;
              width: 50%;
              height: 50%;
              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  .exhibitionSearchBottom {
    margin-bottom: 50px;
    position: relative;
    .section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      padding: 30px 40px;
      .customMadeLeft {
        padding-right: 20px;
        .high {
          font-size: 32px;
          font-family: "fangzang";
        }
        p {
          letter-spacing: 1px;
          font-size: 15px;
          line-height: 24px;
        }
      }
      .customMadeRight {
        div {
          background-color: #931217;
          font-size: 32px;
          font-family: "fangzang";
          color: #fff;
          padding: 10px;
          letter-spacing: 2px;
          border-radius: 6px;
          white-space: nowrap;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 240px;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .made {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      white-space: normal;
      text-align: center;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      box-shadow: 0 0 10px #99131a;
      margin-bottom: 20px;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .home {
    position: relative;
    .header_mobile_title {
      .eng_header_mobile_title {
        font-size: 0.1rem;
      }
    }
    .dataBaseSearchTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .eng_section {
        font-size: 0.27rem;
      }
    }
    .culturalCustomDetailContent {
      background: url("../../assets/newImage/index/could_right.png") no-repeat
        right bottom;
      background-size: 1rem;
      position: relative;
      padding-bottom: 0.5rem;
      .section {
        .one {
          .content_top {
            margin: 0.5rem 0;
            text-align: justify;
            div {
              padding: 0.2rem 0.1rem;
            }
          }
          .content_middle {
            .item {
              width: 1.56rem;
              height: 1.56rem;
              margin: 0 0.21rem 0.22rem 0;
              img {
                width: 1.56rem;
                height: 1.56rem;
              }
            }
            .item:nth-child(6n) {
              margin-right: 0.21rem;
            }
          }
          /deep/.loading {
            margin-top: 20px;
          }
          .algorithm {
            .content {
              padding: .2rem;
              .photo {
                width: 90% !important;
              }
            }
          }
        }
      }
      .cloudright {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.25rem;
      }
    }
    .exhibitionSearchBottom {
      padding: 0 0.2rem;
      .section {
        display: flex;
        flex-direction: column;
        padding: 0.5rem 0.2rem;
        .customMadeLeft {
          padding: 0.2rem 0 0.5rem 0;
          .high {
            font-size: 0.4rem;
            text-align: center;
          }
        }
        .customMadeRight {
          display: flex;
          justify-content: center;
          div {
            font-size: 0.4rem;
          }
        }
      }
    }
    .contact {
      bottom: 35%;
      right: 1%;
      z-index: 1000;
      .made {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
